// extracted by mini-css-extract-plugin
module.exports = {"loadSpinner":"loadspinner_loadSpinner__A8oyp","spin":"loadspinner_spin__s1onh"};